import React from 'react';
import ProductPicker from "./ProductPicker";
import SingleItemImageDisplay from "./SingleItemImageDisplay";

export default function ItemClusterImages({
  product, products, itemCache, clusterState, showZoom=false
}) {
  const productPicker = new ProductPicker({products, itemCache, clusterState});
  product ||= productPicker.getProductForImage();

  return <div className="text-center min-h-4">
    {product && <SingleItemImageDisplay product={product} showZoom={showZoom}/>}
  </div>
}

